import React from "react"
import { FunctionComponent } from "react"

const Conditional: FunctionComponent<{ predicate: any; negate?: boolean }> = ({
    predicate,
    negate,
    children,
}) => {
    if (negate) {
        if (!predicate) {
            return <>{children}</>
        }

        return null
    }

    if (predicate) {
        return <>{children}</>
    }

    return null
}

export default Conditional
